
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop({ default: false }) visible: boolean
  @Prop() data: {
    imgList: string[]
    text: string
    type: 'jump' | 'download'
    jumpUrl: string
  }

  handleGo() {
    if (!this.data.jumpUrl) return

    window.open(this.data.jumpUrl)
  }

  @Emit('close')
  onClose() {}

  // 生命周期钩子
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
